import * as Menu from "@radix-ui/react-dropdown-menu";
import { ChevronDown, LogOut, Settings, Shield } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { api, call } from "../lib/api";
import { useSession } from "../lib/session";
import { Avatar } from "./Avatar";

export function UserMenu() {
  const { t } = useTranslation();
  const me = useSession();
  const navigate = useNavigate();
  const first = me.name.split(" ")[0] ?? me.name;
  const role = me.roles[0];

  async function signOut() {
    const res = await call<{ end_session_url: string | null }>(api.POST("/app/v1/auth/logout"));
    window.location.assign(res.end_session_url ?? "/signed-out");
  }

  return (
    <Menu.Root>
      <Menu.Trigger
        className="flex items-center gap-3 rounded-[var(--radius-card)] py-1 pl-1 pr-2 hover:bg-elevated"
      >
        <Avatar name={me.name} size={44} />
        <span className="hidden text-left leading-tight lg:block">
          <span className="block text-[15px] font-semibold text-ink">{first} </span>
          <span className="block text-[12px] text-ink-2">{role ? t(`role.${role}`) : null}</span>
        </span>
        <span className="sr-only">{t("shell.user_menu_label")}</span>
        <ChevronDown aria-hidden="true" className="size-4 text-ink-3" />
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Content
          align="end"
          sideOffset={8}
          className="z-50 min-w-52 rounded-[var(--radius-card)] border border-line bg-surface p-1 shadow-[var(--shadow-card)]"
        >
          <Menu.Item
            onSelect={() => navigate("/settings")}
            className="flex cursor-pointer items-center gap-2 rounded-[var(--radius-control)] px-3 py-2 text-[14px] text-ink outline-none data-[highlighted]:bg-elevated"
          >
            <Settings aria-hidden="true" className="size-4 text-ink-2" />
            {t("shell.open_settings")}
          </Menu.Item>
          {me.permissions["admin.configure"] && (
            <Menu.Item
              onSelect={() => navigate("/admin")}
              className="flex cursor-pointer items-center gap-2 rounded-[var(--radius-control)] px-3 py-2 text-[14px] text-ink outline-none data-[highlighted]:bg-elevated"
            >
              <Shield aria-hidden="true" className="size-4 text-ink-2" />
              {t("nav.admin")}
            </Menu.Item>
          )}
          <Menu.Separator className="my-1 h-px bg-[var(--border-default)]" />
          <Menu.Item
            onSelect={() => void signOut()}
            className="flex cursor-pointer items-center gap-2 rounded-[var(--radius-control)] px-3 py-2 text-[14px] text-ink outline-none data-[highlighted]:bg-elevated"
          >
            <LogOut aria-hidden="true" className="size-4 text-ink-2" />
            {t("shell.sign_out")}
          </Menu.Item>
        </Menu.Content>
      </Menu.Portal>
    </Menu.Root>
  );
}
